// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./custom.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { Chart as ChartJS } from 'chart.js';
ChartJS.defaults.font.family = "'Kanit', sans-serif";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
